<div class="clickable" (click)="toggleAlternative()">
    <relative-time
    *ngIf="!showAlternative"
    [attr.datetime]="datetime"
    [attr.format]="format"
    [attr.lang]="lang"
    >{{ fallbackText | ucfirst}}</relative-time>
    
    <span *ngIf="showAlternative">{{ datetime | date: 'longDate' : undefined : locale | ucfirst }}</span>
</div>